// extracted by mini-css-extract-plugin
export var carousel = "styles-module--carousel--d9c98";
export var container = "styles-module--container--54282";
export var desktop = "1340px";
export var giant = "2200px";
export var header = "styles-module--header--ba58c";
export var inset = "styles-module--inset--36506";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "768px";